import React from 'react'
import { Button } from '@/components/ui/button'

class ClaimLeadButton extends React.Component {

  onClick = (e) => {
    e.stopPropagation()
    this.props.store.emit('lead:claim', this.props.lead_id)
  }

  render() {
    return (
      <div>
        {this.props.sales_manager ?
          <Button variant="warning" className="m-[1%] h-[60px] w-[98%] text-[20px] font-bold" onClick={this.onClick}>Claim Lead from {this.props.sales_manager.name}</Button>
          :
          <Button variant="success" className="m-[1%] h-[60px] w-[98%] text-[20px] font-bold" onClick={this.onClick}>Claim Lead</Button>
        }
      </div>
    )
  }
}

export default ClaimLeadButton
